// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"cabfffa7","87":"0a7ef04d","186":"8aa7b550","193":"5ffa1d3f","241":"c1d543da","449":"8aa7b550","504":"c1d543da","520":"35402fc9","860":"df42293c"}[chunkId] + ".css";
};